<template>
    <div>
        <span v-if="favorited" @click="toggle" class="clickable">
            <i class="fa fa-heart me-1"></i> {{ __('Remove from favorites') }}
        </span>
        <span v-else @click="toggle" class="clickable">
            <i class="fa fa-heart-o me-1"></i> {{ __('Add to favorites') }}
        </span>
    </div>
</template>

<script>
    export default {
        props: ['init', 'id'],
        data() {
            return {
                favorited : false,
            }
        },
        methods: {
            toggle() {
                axios.post('/favorite-exhibitors/'+ this.id +'/toggle')
                    .then(response => {
                        this.favorited = !this.favorited;
                    });
            }
        },
        mounted() {
            this.favorited = this.init;
        },
    }
</script>
